import { PolicyViewModel, WalkAndPunchApiClient } from 'src/proxy/api/walkandpunch-api.proxy';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { flattenDeep } from 'lodash-es';
import { from, Observable } from 'rxjs';

@Injectable()
export class PolicyService {
  private policiesEnum: PolicyViewModel[] = [];
  private policies$: Observable<PolicyViewModel[]> = null;

  constructor(private authCoreService: WalkAndPunchApiClient) {
    // this.loadPolicies();
  }

  get policies() {
    return this.policiesEnum;
  }

  hasPolicies() {
    return this.policiesEnum && this.policiesEnum.length > 0;
  }

  loadPolicies() {
    this.policies$ = from(this.authCoreService.v1AuthCoreGetPoliciesGET()).pipe(map((policies) => (this.policiesEnum = policies)));
    return this.policies$;
  }

  getRolesFromPolicies(names: string[]): string[] {
    const claims: string[] = flattenDeep(this.policies.filter((p) => names.includes(p.name)).map((p) => p.requiredClaimValues));
    if (!claims) {
      return [];
    }
    return [...new Set(claims)];
  }
}
